<ng-container *ngTemplateOutlet="chipTemplateRef"></ng-container>
<ng-content *ngIf="!assignee"></ng-content>

<ng-template #assigneeChip>
  <ui-assignee [uiAssignee]="assignee" [uiNameEllipsis]="true" [uiNameMultiline]="true" uiSize="sm"></ui-assignee>
</ng-template>

<ng-template #dotChip>
  <div class="ui-chip-circle" [ngStyle]="{ 'background-color': dotColor }"></div>
</ng-template>

<ng-template #iconChip>
  <i [uiType]="icon.type" [uiTheme]="icon.theme" ui-icon></i>
</ng-template>

<button
  class="ui-chip-button"
  *ngIf="nzMode === 'closeable' && showCloseIcon"
  [attr.data-test-id]="'remove-owner-' + assignee.name"
  [tabindex]="-1"
  (click)="closeTag($event)"
  ui-button
  uiSize="small"
  uiShape="circle">
  <i ui-icon uiType="close-medium"></i>
</button>
